<template>
    <b-modal @hide="hide" v-if="modalAction" id="seasonRateManagementModal" :title="modalAction.Title" size="x"
        hide-footer no-close-on-backdrop>

        <b-container>
            <b-row>
                <b-col cols="12">
                    <NextFormGroup :title="$t('Your TextArea Field Title')" :error="$v.customerCodesTextarea" md="12" lg="12">
                        <b-form-textarea v-model="customerCodesTextarea" placeholder="Enter customer codes here"
                            rows="5"></b-form-textarea>
                    </NextFormGroup>
                </b-col>
                
            </b-row>
            <b-row>
                <b-col class="text-right" cols="12">
                    <b-button class="mx-2" @click="save" size="sm" variant="danger">{{ $t('index.remove') }}</b-button>
                </b-col>
            </b-row>
        </b-container>

    </b-modal>

</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
    name: 'SeasonRateManagementModal',
    props: {
        modalAction: {
            type: Object,
            default: () => { },
            description: 'Sayfadan seçilen action bilgisi'
        }
    },
    data() {
        return {
            customerCodesTextarea: '',
        }
    },
    validations() {
        return {
            customerCodesTextarea: { required }
        }
    },
    mounted() {},
    methods: {
        hide() {
            if (this.$v) {
                this.$v.$reset()
            }
        },
        save() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$toasted.show(this.$t('insert.requiredFields'), {
                    type: 'error',
                    keepOnHover: true,
                    duration: 3000
                })
                return
            }
            const customerCodesArray = this.customerCodesTextarea
                .split('\n')
                .filter(line => line.trim() !== '')
                .map(code => code.trim());

            console.log('Codes Array', customerCodesArray)

            let customerRequest = {
                'orConditionModels': [
                    {
                        'codes': customerCodesArray
                    }
                ]
            }
            this.$api.postByUrl(customerRequest, 'VisionNextCustomer/api/Customer/CustomerSeasonRateDeleted').then((res) => {
                if (res.IsCompleted == true) {
                    if (res.ListModel.BaseModels.length > 0) {
                        this.$toasted.show(this.$t('index.success'), {
                            type: 'success',
                            keepOnHover: true,
                            duration: '3000'
                        })
                        this.closeModal();
                        this.$store.dispatch('getTableData', {
                            ...this.query,
                            apiUrl: '/VisionNextCustomer/api/Customer/Search',
                            api: 'Customer',
                            page: 1,
                            count: 20,
                            search: {},
                            andConditionalModel: {  },
                            OrderByColumns: [{column: "CreatedDateTime", orderByType: 1}],
                        }).then(() => {
                        }).catch(() => {
                     })
                    }
                    else {
                        this.$toasted.show(this.$t('index.customerNotFound'), {
                            type: 'error',
                            keepOnHover: true,
                            duration: '3000'
                        })
                    }
                }
            })
        },
        closeModal() {
            this.$root.$emit('bv::hide::modal', 'seasonRateManagementModal')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Actions/SeasonRateManagementModal.vue